<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h"><span><i>Translator’s Note</i></span></p>
<p class="normal">This text has been translated not only into English, but into the English of recent times. It therefore includes, where appropriate, ‘contemporary’ words such as <i>downside</i>, or even ‘foreign’ words and phrases such as <i>doppelgänger</i> or <i>par excellence</i>. This method is employed in order to correspond with the syntax of the original scrolls, which themselves are written in a style of their own period, and include expressions and phrases from many areas and other tongues.</p>
<p class="indent">As with the main text, names, where they are exactly translatable, are rendered (often) in English, and sometimes both in English and the original vernacular – for example the name/title, <i>Lionwolf</i> (<i>Vashdran</i> in the Rukarian). Occasionally names are given in a combination of exactly equivalent English plus part of the existing name where it is basically <i>un</i>translatable, as with the Rukarian Phoenix, the <i>Firefex</i>. Note too perhaps the name <i>Jemhara</i>, which is a mix of Rukarian (<i>Jema</i>) and Latin (<i>hara</i>: hare), resorted to since in the original this second part of her name, which refers to her shape-changing, uses an obscure and ancient scholastic tongue of Ruk Kar Is.</p>
<p class="indent">A final point. Among Rukarians to abbreviate or alter the ending of a name may be a sign of affection. But to change or deform the first letter – as with <i>Pth</i> for <i>Zth</i> – is always a grave insult.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter02.vue?f26de3fe